module.exports = __webpack_public_path__ + "img/key-result-check.05aee085.svg";